import validator from 'validator';

const validatePassword = (password: string, cpassword: string) => {
    if (validator.isEmpty(password)) {
        return {
            isValid: false,
            message: 'Veuillez remplir ce champ',
        };
    }
    if (validator.isEmpty(cpassword)) {
        return {
            isValid: false,
            message: 'Veuillez confirmer votre mot de passe',
        };
    }
    if (password !== cpassword) {
        return {
            isValid: false,
            message: 'Les mots de passe ne correspondent pas',
        };
    } else
        return {
            isValid: true,
            message: '',
        };
};

export default validatePassword;
